//判断是ios或者是android
const u = navigator.userAgent;
const appSource = u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) ? 'ios' : 'andriod';
export default appSource;